// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { DiscountShape, CodeCircle, Play, Magicpen, Flag } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';
import { NavActionType } from 'types/config';

// icons
const icons = {
  offers: DiscountShape,
  feed: CodeCircle,
  video: Play,
  aiGenerator: Magicpen,
  salesService: Flag
};

// ==============================|| MENU ITEMS - TOOLS ||============================== //

const tools: NavItemType = {
  id: 'tools-group',
  title: <FormattedMessage id="common.menu.tools.group" />,
  type: 'group',
  children: [
    {
      id: 'offers',
      title: <FormattedMessage id="common.menu.tools.offers" />,
      type: 'item',
      url: '/tools/offers',
      icon: icons.offers,
      actions: [
        {
          type: NavActionType.EVENT,
          event: 'offers',
          label: 'common.menu.tools.offers',
          icon: icons.video,
          payload: {
            title: 'common.menu.tools.offers',
            videoUrl: 'https://medianewbuild.com/file/hh-media-bucket/utils/agent/offers.mp4'
          }
        }
      ]
    },
    {
      id: 'feed',
      title: <FormattedMessage id="common.menu.tools.feed" />,
      type: 'item',
      url: '/tools/feed',
      icon: icons.feed,
      actions: [
        {
          type: NavActionType.EVENT,
          event: 'feed-xml',
          label: 'common.menu.tools.feed',
          icon: icons.video,
          payload: {
            title: 'common.menu.tools.feed',
            videoUrl: 'https://medianewbuild.com/file/hh-media-bucket/utils/agent/feed_xml.mp4'
          }
        }
      ]
    },
    {
      id: 'ai',
      title: <FormattedMessage id="common.menu.tools.aiGenerator" />,
      type: 'item',
      url: '/tools/ai-generator',
      icon: icons.aiGenerator,
      breadcrumbs: false,
      actions: [
        {
          type: NavActionType.EVENT,
          event: 'ai-description-tool',
          label: 'aiGenerator.descriptionTool',
          icon: icons.video,
          payload: {
            title: 'aiGenerator.descriptionTool',
            videoUrl: 'https://medianewbuild.com/file/hh-media-bucket/utils/agent/ai_description_tool.mp4'
          }
        }
      ]
    },
    {
      id: 'sales-service',
      title: <FormattedMessage id="common.menu.tools.salesService" />,
      type: 'item',
      url: '/tools/sales-service',
      icon: icons.salesService,
      breadcrumbs: false
    }
  ]
};

export default tools;
